import { Box, Tooltip, TooltipProps } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';
import styles from './SGSTooltip.module.scss';

type Props = TooltipProps & {
    clickable?: boolean;
};

const SGSTooltip: React.FC<PropsWithChildren<Props>> = ({ children, clickable = false, ...props }) => {
    return (
        <Tooltip {...props} arrow classes={{ popper: styles.root, tooltip: styles.tooltip, arrow: styles.arrow }} TransitionProps={{ timeout: 0 }}>
            <Box className={clickable ? styles.pointer : styles.content}>{children}</Box>
        </Tooltip>
    );
};

export default SGSTooltip;
